import "./index.scss";
function Nav_menu_list() {
    return (
        <div className="nav_menu_list">
            <a className="nav_menu_item" href="https://www.facebook.com/NTUTBlockchain/" target="_blank" rel="noopener noreferrer">Facebook</a>
            <a className="nav_menu_item" href="https://discord.gg/T49uBSxenv" target="_blank" rel="noopener noreferrer">Discord</a>
            <a className="nav_menu_item" href="https://line.me/ti/g2/OpW9YDQ3jLDCwRjYyywChRIHoStpMffsFdD8MA" target="_blank" rel="noopener noreferrer">Line</a>
            <a className="nav_menu_item" href="https://www.instagram.com/ntut.blockchain" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a className="nav_menu_item" href="https://forms.gle/ujojLJjK2A7cf5jQ7" target="_blank" rel="noopener noreferrer">加入我們！</a>
        </div>
    );
}
export default Nav_menu_list;
